import * as React from 'react';
import Svg, { SvgProps, G, Path } from 'react-native-svg';

function SvgComponent(props: SvgProps) {
  return (
    <Svg width={29} height={39} {...props}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M14.439 38c7.422 0 13.439-6.017 13.439-13.439 0-5.796-3.669-10.734-8.81-12.62-.743.712-1.669 1.616-2.776 2.713a2 2 0 01-2.799.015c-1.508-1.462-2.534-2.44-3.078-2.934C4.96 13.445 1 18.54 1 24.56 1 31.983 7.017 38 14.439 38z"
          stroke="#247A9C"
          strokeWidth={1.5}
        />
        <Path
          d="M8.861 18.359h11.03v1.575H8.86V18.36zm-1.229 4.616h13.63v1.592h-4.176v5.325c0 .41.173.615.536.615h1.733c.189 0 .347-.126.441-.363.11-.252.19-1.024.22-2.3l1.482.472c-.11 1.78-.315 2.837-.599 3.167-.284.316-.693.489-1.245.489H17.15c-1.119 0-1.67-.583-1.67-1.733v-5.672h-2.332v.315c-.079 2-.52 3.608-1.323 4.805-.788 1.103-2.049 1.97-3.813 2.584l-.883-1.386c1.702-.599 2.836-1.355 3.435-2.238.599-.977.914-2.221.977-3.765v-.315H7.632v-1.592z"
          fill="#247A9C"
          fillRule="nonzero"
        />
        <Path
          d="M14.717 0c.512 0 .927.415.927.927v9.037l5.106-5.01a.878.878 0 011.15-.07l.09.08.001.001.077.09a.874.874 0 01-.01 1.057l-.078.089-6.554 6.432a.876.876 0 01-.654.25.875.875 0 01-.653-.25L7.565 6.201a.874.874 0 01-.088-1.146l.077-.09.001-.002a.878.878 0 011.24-.01l4.995 4.901V.927c0-.512.415-.927.927-.927z"
          fill="#247A9C"
        />
      </G>
    </Svg>
  );
}

const RedeemIcon = React.memo(SvgComponent);
export default RedeemIcon;
